import { render, staticRenderFns } from "./SolAgoraStep5.vue?vue&type=template&id=12f3da0e&"
import script from "./SolAgoraStep5.vue?vue&type=script&lang=js&"
export * from "./SolAgoraStep5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports